import React from 'react';
import { useLocation } from 'react-router-dom';
import { authService } from '../../services/auth';
import { canAccessRoute } from '../../utils/permissions';
import AccessDenied from '../AccessDenied';

const RoleProtectedRoute = ({ children, requiredPermission = null }) => {
  const location = useLocation();
  const user = authService.getUser();
  const userRole = user?.role;

  console.log('🛡️ RoleProtectedRoute:', { 
    pathname: location.pathname, 
    userRole, 
    requiredPermission,
    user: user ? { id: user.id, username: user.username, role: user.role } : null
  });

  // If no user or role, show access denied
  if (!user || !userRole) {
    console.log('❌ No user or role, showing access denied');
    return (
      <AccessDenied 
        showBackButton={false}
      />
    );
  }

  // If a specific permission is required, check it
  if (requiredPermission) {
    const hasAccess = canAccessRoute(userRole, location.pathname);
    console.log('🔐 Required permission check:', { requiredPermission, hasAccess });
    if (!hasAccess) {
      console.log('❌ Required permission not met, showing access denied');
      return (
        <AccessDenied 
          requiredPermission={requiredPermission}
          userRole={userRole}
        />
      );
    }
  } else {
    // Check if user can access the current route
    const hasAccess = canAccessRoute(userRole, location.pathname);
    console.log('🔐 Route access check:', { 
      pathname: location.pathname, 
      userRole, 
      hasAccess,
      user: user ? { id: user.id, username: user.username, role: user.role, organization_id: user.organization_id } : null
    });
    if (!hasAccess) {
      console.log('❌ Route access denied, showing access denied');
      console.log('🔍 Debug info:', {
        pathname: location.pathname,
        userRole,
        canAccessRouteResult: canAccessRoute(userRole, location.pathname),
        permissions: require('../../utils/permissions').getUserPermissions(userRole)
      });
      return (
        <AccessDenied 
          userRole={userRole}
        />
      );
    }
  }

  console.log('✅ Access granted, rendering children');
  return children;
};

export default RoleProtectedRoute; 